import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import Typography from "@/components/typography/Typography"
import { Col, Row } from "antd"
import { FC } from "react"
import "./LicenseRequired.less"

const { Title, Paragraph } = Typography

const LicenseRequired: FC = () => {
  const { setIsModalDarkOpen, setModalDarkTypes } = useModalDarkContext()

  const handleContinue = () => {
    setIsModalDarkOpen(false)
  }

  const onUpgradeLicenseClick = () => {
    setModalDarkTypes("license-upgrade-request")
  }

  return (
    <Row justify={"center"} className={"license-required-wrapper"}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={3} centered style={{ paddingBottom: 16 }} color={"white"}>
          <span className={"w300"}>{"Management"}</span>
          <span className={"bold"}>{" of Outgoing Applications"}</span>
        </Title>

        <Row justify={"center"}>
          <SvgIcon type={"starred-award"} className={"icon-wrapper"} />
        </Row>

        <Title level={5} weight={"w300"} color={"white"} centered style={{ paddingBottom: 16, paddingTop: 8 }}>
          {"Unified Control"}
        </Title>

        <Paragraph color={"website-secondary"} weight={"w300"} centered>
          {
            "This feature is available with a full license and provides\nefficient management of outgoing projects and applications.\nTo enable access, please contact us."
          }
        </Paragraph>
      </Col>

      <Col span={16} style={{ paddingBottom: 40, paddingTop: 24 }}>
        <Row justify={"center"}>
          <Button btnType={"text"} className={"license-btn"} onClick={onUpgradeLicenseClick}>
            <div className={"license-offer-wrapper"}>
              <div className={"hexagon-wrapper"}>
                <SvgIcon type={"upload-in-color"} />
              </div>
              <Paragraph color={"website-secondary"} style={{ textAlign: "left" }}>
                {"Upgrade to a licensed package to unlock advanced wayleave management tools and features."}
              </Paragraph>
            </div>
          </Button>
        </Row>
      </Col>

      <Col span={24}>
        <Row justify={"center"}>
          <Button btnType={"primary"} text={"Back to Dashboard".toUpperCase()} onClick={handleContinue} />
        </Row>
      </Col>
    </Row>
  )
}

export default LicenseRequired
